export const blockIconsTravelLunchDiningNew = (
	<span className='material-symbols-outlined'>lunch_dining</span>
);
